/**
 * Copyright 2022 Design Barn Inc.
 */

export const encode = (stateObject: Record<string, unknown>): string => {
  try {
    const stateString = JSON.stringify(stateObject);

    return window.btoa(stateString);
    // eslint-disable-next-line no-empty
  } catch (err) {}

  return '';
};

export const decode = (encodedState: string): Record<string, unknown> => {
  try {
    const stateStr = window.atob(encodedState);

    const state = JSON.parse(stateStr);

    return typeof state === 'object' ? state : {};
    // eslint-disable-next-line no-empty
  } catch (err) {}

  return {};
};
